import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';

@Injectable()
export class BoardResolvesService {

    constructor() {
    }

    getProjectQueries(params: any, project: any, TrackerQueryService: any) {
        return TrackerQueryService.getProjectQueries(
            project.id,
            _.get(project, 'rel.permissions.trackers', {}),
            params.tracker
        );
    }

    getBoard(params: any, BoardRest: any) {
        return BoardRest.getBoard(params.boardId);
    }
}
